import * as React from "react";
import styled, { css } from "styled-components";
import IfInteractive from "views/components/dashboard/IfInteractive";
import { IfPermitted, Timestamp, Link } from "components/common";
import AssigneeCell from "security-app/components/common/AssigneeCell";
import RowActionMenu from "security-app/components/Investigations/RowActionMenu";
import { useIsInteractiveMode } from "views/components/contexts/InteractiveContext";
import Routes from "security-app/routing/Routes";
const columnRenderersByType = {
  date: (date) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: date })
};
const Td = styled.td(
  ({ theme }) => css`
    && {
      border-color: ${theme.colors.table.row.divider};
    }
  `
);
const useColumnRenderers = (investigationId, usersAndTeams, priorities) => {
  const interactive = useIsInteractiveMode();
  return {
    created_at: columnRenderersByType.date,
    updated_at: columnRenderersByType.date,
    name: (name) => interactive ? /* @__PURE__ */ React.createElement(Link, { to: Routes.INVESTIGATIONS.details(investigationId) }, name) : /* @__PURE__ */ React.createElement(React.Fragment, null, name),
    assigned_to: (assigneeId) => usersAndTeams[assigneeId] && /* @__PURE__ */ React.createElement(AssigneeCell, { assignee: usersAndTeams[assigneeId] }),
    priority: (value) => {
      var _a;
      return value ? (_a = priorities.find((prio) => prio.priority === value)) == null ? void 0 : _a.text : "";
    }
  };
};
const InvestigationsTableRow = ({ investigation, fields, usersAndTeams, priorities, onArchive, onDelete }) => {
  const columnRenderers = useColumnRenderers(investigation.id, usersAndTeams, priorities);
  return /* @__PURE__ */ React.createElement("tr", { key: investigation.id }, fields.toArray().map((field) => {
    const value = investigation[field];
    const columnRenderer = columnRenderers[field];
    return /* @__PURE__ */ React.createElement(Td, { key: field }, columnRenderer ? columnRenderer(value) : value);
  }), /* @__PURE__ */ React.createElement(IfInteractive, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "investigations:edit" }, /* @__PURE__ */ React.createElement(Td, null, /* @__PURE__ */ React.createElement(RowActionMenu, { investigation, onArchive, onDelete })))));
};
export default InvestigationsTableRow;
